var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{staticClass:"nav-item nav-dropdown",attrs:{"to":_vm.url,"tag":"li","disabled":""}},[_c('div',{staticClass:"nav-link nav-dropdown-toggle",on:{"click":_vm.handleClick}},[(_vm.icon)?[_vm._v(" "+_vm._s(_vm.name)+" ")]:[_vm._v(" "+_vm._s(_vm.name)+" ")]],2),_c('ul',{staticClass:"nav-dropdown-items"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }